import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { Package } from "@revenuecat/purchases-js";

const publicPlans = [
  { identifier: "monthly", label: "mensual", detail: "⚡ 3 días de prueba gratis · Cancela cuando quieras", highlighted: false },
  { identifier: "yearly", label: "anual", detail: "Un solo pago por 12 meses", highlighted: true },
];

interface PricingPlansSectionProps {
  offerings: Package[];
}

export function PricingPlansSection({ offerings }: PricingPlansSectionProps) {
  return (
    <section id="precios" className="border-y border-border bg-muted/30 py-20 lg:py-28">
      <div className="container mx-auto px-4">
        <div className="mx-auto max-w-3xl text-center">
          <p className="text-sm font-bold uppercase text-primary">Precios claros</p>
          <h2 className="mt-3 text-3xl font-bold sm:text-4xl lg:text-5xl">Elige el tiempo que necesitas</h2>
          <p className="mt-5 text-lg text-muted-foreground">Consulta el precio antes de crear tu cuenta. La compra se completa después del registro.</p>
        </div>

        <div className="mx-auto mt-12 grid max-w-4xl gap-5 md:grid-cols-2">
          {publicPlans.map((plan) => {
            const pkg = offerings.find(o => {
              const oId = o.identifier.toLowerCase();
              const pId = plan.identifier.toLowerCase();
              if (pId === 'yearly' && (oId.includes('yearly') || oId.includes('annual'))) return true;
              return oId.includes(pId);
            });
            const price = pkg?.webBillingProduct?.currentPrice?.formattedPrice || pkg?.rcBillingProduct?.currentPrice?.formattedPrice;
            const displayPrice = price ? (price.includes('MXN') ? price : `${price} MXN`) : "Ver precio";

            return (
              <article key={plan.identifier} className={`relative border bg-background p-7 sm:p-9 ${plan.highlighted ? "border-primary" : "border-border"}`}>
                {plan.highlighted && <span className="absolute right-4 top-4 rounded-md bg-primary px-2.5 py-1 text-xs font-bold text-primary-foreground">Mejor valor</span>}
                <p className="text-sm font-semibold text-muted-foreground">Plan {plan.label}</p>
                <p className="mt-4 text-4xl font-black">{offerings.length > 0 ? displayPrice : "..."}</p>
                <p className="mt-2 text-sm text-muted-foreground">{plan.detail}</p>
                <ul className="mt-8 space-y-3 text-sm">
                  {["Flashcards clásicas y cloze", "Simuladores configurables", "Filtros por fuente", "Progreso y estadísticas"].map((benefit) => (
                    <li key={benefit} className="flex items-center gap-2"><Check className="h-4 w-4 text-primary" />{benefit}</li>
                  ))}
                </ul>
                <Link to={`/auth?intent=checkout&plan=${encodeURIComponent(plan.identifier)}`} className="mt-8 block">
                  <Button variant={plan.highlighted ? "default" : "outline"} size="lg" className="w-full">Elegir {plan.label}<ArrowRight className="h-4 w-4" /></Button>
                </Link>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
